document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('[data-dx-mobile-panel]');
  const menuToggles = [...document.querySelectorAll('[data-dx-menu-toggle]')];
  const setMenu = (open) => {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuToggles.forEach((button) => button.setAttribute('aria-expanded', open ? 'true' : 'false'));
    document.body.style.overflow = open ? 'hidden' : '';
  };

  menuToggles.forEach((button) => button.addEventListener('click', () => setMenu(!panel?.classList.contains('is-open'))));

  document.querySelectorAll('[data-dx-thumb]').forEach((button) => button.addEventListener('click', () => {
    const main = document.querySelector('[data-dx-main-image], #DxMainImage');
    if (!main) return;
    main.src = button.dataset.src;
    main.srcset = '';
    document.querySelectorAll('[data-dx-thumb]').forEach((thumbnail) => thumbnail.setAttribute('aria-current', 'false'));
    button.setAttribute('aria-current', 'true');
  }));

  document.querySelectorAll('[data-dx-qty]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      const delta = button.dataset.delta === 'plus' ? 1 : -1;
      input.value = Math.max(1, parseInt(input.value || '1', 10) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  document.querySelectorAll('[data-dx-variant-radio]').forEach((radio) => radio.addEventListener('change', () => {
    const price = document.querySelector('[data-dx-price]');
    const compare = document.querySelector('[data-dx-compare]');
    const sticky = document.querySelector('[data-dx-sticky-price]');
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;
    if (sticky && radio.dataset.price) sticky.textContent = radio.dataset.price;
    if (compare) compare.textContent = radio.dataset.compare || '';
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', radio.value);
    window.history.replaceState({}, '', nextUrl);
  }));

  document.querySelectorAll('[data-dx-sticky-submit]').forEach((button) => button.addEventListener('click', () => {
    const form = document.querySelector('[data-dx-product-form], #DxProductForm');
    if (form) form.requestSubmit();
  }));
});
